// extracted by mini-css-extract-plugin
export default {"page":"jZ-z","cartModal":"kZ-z","checkout":"lZ-z","placeholder":"mZ-z","account":"nZ-z"};